import { createFilterForEntity } from './createFilterForEntity';
import { EntityRequest } from '../schema/SubstrateSearchRequest';
import { SubstrateContentSource } from '../schema/SubstrateContentSource';
import { SubstrateEntityType } from '../schema/SubstrateEntityType';

/** Return the EntityRequest object for 3S query API call
 * @param queryString queryString for the search
 * @param entityType SubstrateEntityType requested for
 * @param from offset from where to fetch results
 * @param size number of results to be fetched
 */
export function createSubstrateEntityRequest(
    queryString: string,
    entityType: SubstrateEntityType,
    from: number,
    size: number,
    currentFolderScopeId?: string,
    displayQueryString?: string
): EntityRequest {
    return {
        EntityType: entityType,
        ContentSources: [SubstrateContentSource.Exchange],
        Query: {
            QueryString: queryString,
            DisplayQueryString: displayQueryString,
        },
        From: from,
        Size: size,
        Filter: createFilterForEntity(entityType, currentFolderScopeId),
    } as EntityRequest;
}
